import Page from '@modules/page'
import {navigate, useParams} from "@reach/router"
import {ContextualSaveBar, Layout, PageActions, Button} from "@shopify/polaris"
import {ContextProvider, useStore} from "@pages/bundles/container"
import TitleCard from "./components/title"
import DiscountCard from "./components/discount"
import ProductsCard from "./components/products"
import StatusCard from "./components/status"
import LayoutCard from "./components/layout"
import {useCallback, useEffect, useState} from "react"
import API from "@helpers/api"
import {showToast} from "@plugins/toast"
import {Skeleton} from "@modules/skeleton"
import StatusBadge from "@components/statusBadge"
import {CancelToken} from "@plugins/axios"
import {checkRequiredFields} from "@helpers/utils"
import {ViewMinor} from '@shopify/polaris-icons'
import {useAuthStore} from "../../container/Auth"
import {showConfirm} from "@plugins/confirm"
import { isEqual, omit } from 'lodash'
import DiscardModal from '../../components/discardModal'

const EditBundle = () => {
	return (
		<ContextProvider>
			<EditBundleView />
		</ContextProvider>
	)
}

const EditBundleView = () => {
	const [ready, setReady] = useState(false)
	const [saving, setSaving] = useState(false)
	let [error, setError] = useState([])
	const {pageID} = useParams()
	const {state, dispatch} = useStore()
	const source = CancelToken.source()
	const [activeModal, setActiveModal] = useState(false);
	const {active, title, target_product, products, _id} = state
	const [prevState, setPrevState] = useState({})

	const isEqualState = isEqual(omit(state, ['created_at', 'updated_at', 'heading', 'product', 'updatedAt']), omit(prevState, ['updatedAt']))

	const handleModalChange = useCallback(() => setActiveModal(!activeModal), [activeModal]);

	useEffect(() => {
		const handleReloadPage = (e) => {
		  e.preventDefault()
		  e.returnValue = ""
		}
		if(isEqualState === false) window.addEventListener("beforeunload", handleReloadPage)
		return () => window.removeEventListener("beforeunload", handleReloadPage)
	  }, [isEqualState])
	useEffect(() => {
		let result
		const fetchData = async () => {
			try {
				result = await API.getDetail('bundle', pageID, source.token)
				console.log('Data details', result)
				if (result && result.ok && result.payload) {
					dispatch({type: 'setData', payload: result.payload})
					setPrevState(result.payload)
					setReady(true)
				}
			} catch (error) {
				console.log(error)
			}
		}
		fetchData()
		return () => source.cancel()
	}, [pageID])
	const handleSave = async () => {
		error = await checkRequiredFields(['title', 'products'], state)
		if (error.length > 0) {
			setError(error)
			window.scrollTo({top: 0, behavior: 'smooth'})
			return showToast({
				message: 'Please fill in all the mandatory fields',
				error: true
			})
		}

		setSaving(true)
		const {products, target_product} = state
		if (products?.length && !target_product) state['target_product'] = products[0]?.value
		API.update('bundle', {
			...state,
			products: products.map(p => p?.value)
		}).then((res) => {
			if (res.ok) {
				setPrevState({...prevState, ...res.payload, products: products})
				return showToast({
					message: 'Updated successfully'
				})
			}
		}).finally(() => setSaving(false))
	}
	const handleDelete = () => {
		showConfirm({
			title: `Delete ${title}?`,
			message: 'This can’t be undone.',
			danger: true,
			confirm: 'Delete'
		}).then(res => {
			if (res) {
				API.bulkDelete('bundle', [_id]).then((res) => {
					console.log(res)
					if (res.ok) {
						showToast({
							message: 'Bundle(s) deleted'
						})
						return navigate('/bundles')
					} else {
						showToast({
							message: 'Cannot delete, please try again',
							error: true
						})
					}
				})
			}
		})
	}

	const {shop_domain} = useAuthStore()

	const target = products.find(p => p?.value === target_product)

	return ready ? (
		<Page
			title={title}
			breadcrumbs={[{content: 'Bundles', onAction: () => isEqualState ? navigate('/bundles') : handleModalChange()}]}
			titleMetadata={<StatusBadge status={active} />}
			primaryAction={
				target ? <Button
					icon={ViewMinor}
					onClick={() => window.open(`https://${shop_domain}/products/${target?.handle}`)}
				>Preview</Button> : ''
			}
		>
			{!isEqualState && <ContextualSaveBar
				message="Unsaved changes"
				saveAction={{
					onAction: handleSave,
					loading: saving,
					disabled: false,
				}}
				discardAction={{
					onAction: () => handleModalChange(),
				}}
			/>}
			<Layout>
				<Layout.Section>
					<TitleCard error={error} />
					<ProductsCard error={error} />
					<LayoutCard />
				</Layout.Section>
				<Layout.Section secondary>
					<StatusCard />
					<DiscountCard />
				</Layout.Section>
			</Layout>
			<PageActions
				primaryAction={{
					content: 'Save',
					loading: saving,
					onAction: handleSave

				}}
				secondaryActions={[
					{
						content: 'Delete',
						destructive: true,
						onAction: handleDelete
					},
				]}
			/>
			<DiscardModal
				activeModal={activeModal}
				handleModalChange={handleModalChange}
				backLink='/bundles'
			/>
		</Page>
	) : <Skeleton />
}

export default EditBundle
